/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module scrollToTOp
 */
(function () {

    /**
     * Handle scrollToTop
     * @param scrollToTopBtn {String} mainNav identifier
     * @method scrollToTop
     */
    function ScrollToTop(scrollToTopBtn) {
        /**
         * local object availability
         * @type {ScrollToTop}
         * @private
         */
        var _this = this;

        /**
         * class to hide the scroll to top button
         * @type {string}
         * @private
         */
        this.hiddenClass = 'scroll-to-top--hidden'

        /**
         * Distance after which the scrollToTop button should be visible
         * @type {number}
         * @private
         */
        this.btnVisibleAfterDistance = window.innerHeight / 2;

        /**
         * Handle hiding of the scroll to top button
         * @method hide
         * @returns {undefined}
         */
        this.hide = function () {
            scrollToTopBtn.classList.add(_this.hiddenClass);
            scrollToTopBtn.blur()
        }

        /**
         * Handle showing the scroll to top button
         * @method show
         * @returns {undefined}
         */
        this.show = function () {
            scrollToTopBtn.classList.remove(_this.hiddenClass);
        }

        /**
         * update the button visibility based on the current scroll position
         * @method updateBtnVisibility
         * @returns {undefined}
         */
        this.updateBtnVisibility = function () {
            if (window.scrollY > _this.btnVisibleAfterDistance){
                _this.show()
            } else{
                _this.hide();
            }
        }

        /**
         * Bind the scroll event to handle the visibility of the scrollToTop
         * @method bindScrollEvent
         * @returns {undefined}
         */
        this.bindScrollEvent = function () {
            window.addEventListener("scroll",function(e){
                _this.updateBtnVisibility();
            })
        }

        /**
         * Bind the click event of the scrollToTop button to scroll to the top
         * @method hide
         * @returns {undefined}
         */
        this.bindBtnClickEvent = function () {
            scrollToTopBtn.addEventListener('click', function (){
                _this.hide();
                $('html, body').animate({
                    scrollTop: 0
                }, 500)
            })
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.updateBtnVisibility();
            _this.bindScrollEvent();
            _this.bindBtnClickEvent();
        };


        /**
         * initially call scrollToTop
         */
        _this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.ScrollToTop = ScrollToTop;
})();

$(function () {
    var scrollToTopBtn = document.querySelector('[data-js="scroll-to-top"]');
    if (scrollToTopBtn) {
        new window.Jumpers.ScrollToTop(scrollToTopBtn);
    }
});
